import { useEffect } from "react";
import toast, { Toaster, ToastBar, useToasterStore } from "react-hot-toast";

const NotificationHost = () => {
    const { toasts } = useToasterStore();

    useEffect(() => {
        // The public store is newest-first. Remove overflow rather than queueing it.
        toasts.filter(item => item.visible).slice(5).forEach(item => toast.remove(item.id));
    }, [toasts]);

    return (
        <Toaster
            position="bottom-right"
            gutter={8}
            containerClassName="tmd-notifications"
            containerStyle={{ zIndex: 2100, top: 16, right: 16, bottom: 16, left: 16 }}
            toastOptions={{ duration: 5000 }}
        >
            {item => (
                <ToastBar toast={item} style={{
                    background: "var(--notification-background)",
                    color: "var(--notification-color)",
                    maxWidth: "min(400px, calc(100vw - 32px))",
                    padding: "12px",
                }}>
                    {({ icon, message }) => <>
                        {icon}
                        {message}
                        <button
                            type="button"
                            className="tmd-notification-close"
                            aria-label="Dismiss notification"
                            onClick={() => toast.dismiss(item.id)}
                        >
                            <span aria-hidden="true">×</span>
                        </button>
                    </>}
                </ToastBar>
            )}
        </Toaster>
    );
};

export default NotificationHost;
